namespace $.$$ {
	export class $shm_hitalama_textbook_tree extends $.$shm_hitalama_textbook_tree {
		override content_left( id: string ) {
			// Maps/widgets use a 1rem item inset followed by the standard link padding.
			return `${ Number.parseFloat( super.content_left( id ) ) + 2 }px`
		}
	}
}
